import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import React, { useState } from "react";
import Filters from "../../modal/FeedModals/Filters/Filters";
import { useNavigation } from "@react-navigation/native";
import Brand from "../../assets/Icons/BrandIcons";
import FeedIcons from "../../assets/Icons/FeedIcons";


export default function Navbar({
  filters,
  setFilters,
  handleFiltersChange,
}: {
  filters: any;
  setFilters: any;
  handleFiltersChange: any;
}) {
  const navigation = useNavigation();
  const [isFilterModalVisible, setFilterModalVisible] = useState(false);
  const toggleFilterModal = () => {
    setFilterModalVisible(!isFilterModalVisible);
  };
  return (
    <View style={styles.Navbar}>
      <Filters
        filters={filters}
        setFilters={setFilters}
        isVisible={isFilterModalVisible}
        toggleModal={toggleFilterModal}
        handleFiltersChange={handleFiltersChange}
      />
      <Brand.BlackLogo />
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          width: 60,
        }}
      >
        <TouchableOpacity
          onPress={() => {
            navigation.navigate("notification" as never);
          }}
        >
          <FeedIcons.Notification />
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => {
            toggleFilterModal();
          }}
        >
          <FeedIcons.Filter />
        </TouchableOpacity>
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  Navbar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: 16,
    paddingBottom: 5,
    width: "100%",
    // backgroundColor: "red",
  },
});
